import ImageResize from 'quill-image-resize-module-react';
import Quill from 'quill';

Quill.register('modules/imageResize', ImageResize);

const toolbarOptions: any[] = [
    
    [
        "clean"
    ],
    [
        "bold",
        "italic",
        "underline",
        "strike"
    ],
    [
        { color: [] },
        { background: [] }
    ],
    [
        { list: "bullet" },
        { list: "ordered" },
        { indent: "-1" },
        { indent: "+1" },
    ],
    [
        "link",
        "image"
    ]
];

const modules: any = {
    toolbar: {
        container: toolbarOptions,
        handlers: {},
    },
    clipboard: {
        matchVisual: true,
    },
    imageResize: {
        parchment: Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    }    
};

const formats = [
    "background",
    "bold",
    "color",
    "image",
    "indent",
    "italic",
    "link",
    "list",
    "underline",
    "script",
    "strike"
];

export { modules, formats };